import React, {Component} from "react";
import {Modal, ModalBody, ModalHeader} from 'reactstrap'
import UpdateEventItem from "./UpdateEventItem";

class ModalUpdateEvent extends Component {
    constructor(props) {
        super(props);
        this._handleOpenModal = this._handleOpenModal.bind(this);
        this._handleCloseModal = this._handleCloseModal.bind(this);
    }

    _handleOpenModal() {
        this.props.onOpenModal()
    }

    _handleCloseModal() {
        this.props.onCloseModal()
    }

    render() {
        const {isModelDisplay, onUpdate, event} = this.props
        return (
            <Modal isOpen={isModelDisplay} toogle={this._handleOpenModal}>
                <ModalHeader toggle={this._handleCloseModal}>Edit Event</ModalHeader>
                <ModalBody><UpdateEventItem onUpdate={onUpdate} event={event}
                                            onCloseModal={this._handleCloseModal}/></ModalBody>
            </Modal>
        )
    }
}

export default ModalUpdateEvent


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/events/EventItem/ModalUpdateEvent.js